// extracted by mini-css-extract-plugin
export default {"wrapper":"Gamepad_wrapper__Tvpbt","content":"Gamepad_content__cUkIO","title":"Gamepad_title__9b6kx","text":"Gamepad_text__uKK0A","image":"Gamepad_image__WpqSf"};